import type { PricingVersionTuple } from '../../model/model.ts'

import type { FrRcpwPricingVersionFormat } from './model.ts'

export const frRcpwPricingVersions = [
  ['pricing-fr-rcp-wakam-1.0.0-2026-06-12', { label: 'Initial version' }],
] as const satisfies PricingVersionTuple<FrRcpwPricingVersionFormat>[]

export type FrRcpwPricingVersion = (typeof frRcpwPricingVersions)[number][0]
